import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const [avis, setAvis] = useState([]);

  useEffect(() => {
    axios.get(`${API}/avis`).then((r) => setAvis(r.data)).catch(() => {});
  }, []);

  if (!avis.length) return null;

  return (
    <section id="avis" className="relative py-28 sm:py-36" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          testId="testimonials-heading"
          eyebrow="Avis clients"
          title={
            <>
              Ils nous ont <span className="text-gradient">fait confiance.</span>
            </>
          }
          text="Mariages, anniversaires, soirées d'entreprise : la parole à celles et ceux qui ont dansé avec nous."
        />

        <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {avis.map((a, i) => (
            <Reveal key={a.id} delay={i * 0.08} className="h-full">
              <motion.blockquote
                whileHover={{ y: -6 }}
                transition={{ duration: 0.4 }}
                className="flex h-full flex-col rounded-3xl border border-cyan-500/15 bg-[#0E1524]/70 p-7"
                data-testid={`testimonial-${a.id}`}
              >
                <Quote size={20} className="text-cyan-400" />
                <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-300">« {a.texte} »</p>
                <footer className="mt-6 flex items-end justify-between gap-3">
                  <div>
                    <p className="text-sm font-bold text-slate-100">{a.nom}</p>
                    {a.evenement && <p className="mt-0.5 text-xs text-slate-500">{a.evenement}</p>}
                    {a.source && (
                      <p className="mt-1.5 inline-flex items-center gap-1 rounded-full border border-cyan-400/25 bg-cyan-400/10 px-2.5 py-0.5 text-[10px] font-semibold text-cyan-300">
                        Avis vérifié · {a.source}
                      </p>
                    )}
                  </div>
                  <div className="flex shrink-0 gap-0.5" aria-label={`${a.note} étoiles sur 5`}>
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star
                        key={s}
                        size={13}
                        className={s < a.note ? "fill-amber-300 text-amber-300" : "text-slate-700"}
                      />
                    ))}
                  </div>
                </footer>
              </motion.blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
